import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=678b9046&scoped=true&"
import script from "./Screen.vue?vue&type=script&lang=ts&"
export * from "./Screen.vue?vue&type=script&lang=ts&"
import style0 from "./Screen.vue?vue&type=style&index=0&id=678b9046&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678b9046",
  null
  
)

export default component.exports